import http from "@/utils/http";

//角色列表
export const queryRoles = id => http.get(`/role/mobile/switchRoles.htm`)
//切换角色
export const switchRoles = roleId => http.get(`/login/updateLogin.htm`,{roleId:roleId})
//我的常用服务
export const queryCommonService = top => http.get(`/often/queryServices.htm`,{top:top})
//菜单列表
export const queryMenu = () => http.get(`/nonlogin/mobile/function/queryVisible.htm`)
//我的收藏
export const queryMineCollect = (params) => http.get(`/elobby/mobile/queryFavMobileServices.htm`,params)
//个人中心
export const queryMineAssets = (params) => http.get(`/onewebsitehande/packagedMobileData.htm`,params)